/** Shared types + constants for the ShareCarePlanModal step components. */

export type DeliveryMode = 'email' | 'in-app';
export type PickerTab = 'existing' | 'new';

export const MODE_LABEL: Record<DeliveryMode, string> = {
  email: 'Email Care Guide to client',
  'in-app': 'Send Care Guide to client in-app',
};

export type SharePickerClient = {
  id: string;
  name: string;
  email: string;
};

/**
 * Resolve a human-readable message from a failed share mutation. The apiClient
 * response interceptor flattens every error to `{ message, statusCode, ... }`
 * (see core/api/client.ts `handleResponseError`), so the backend 400 message
 * (e.g. "...already been shared with a client...") lives on `error.message` —
 * NOT `error.response.data.message`. class-validator 400s can make `message` a
 * string[].
 */
export const extractShareError = (error: unknown): string | null => {
  if (!error) return null;
  const message = (error as { message?: string | string[] }).message;
  if (Array.isArray(message)) return message[0] ?? 'Could not share the care guide.';
  return message ?? 'Could not share the care guide. Please try again.';
};
